
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 172 94.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#EB5949","d":"M24.9 21.1h24V31h-24z"}}),_c('path',{attrs:{"fill":"#C5D6D9","d":"M24.9 31h24v12.5h-24z"}}),_c('path',{attrs:{"fill":"#44A7C7","d":"M24.9 43.5h24v16.6h-24z"}}),_c('path',{attrs:{"fill":"#335560","d":"M24.9 60.1h24v23.1h-24z"}}),_c('path',{attrs:{"fill":"#EB5949","d":"M60.8 48.5h24v5h-24z"}}),_c('path',{attrs:{"fill":"#C5D6D9","d":"M60.8 53.5h24V60h-24z"}}),_c('path',{attrs:{"fill":"#44A7C7","d":"M60.8 60h24v9.5h-24z"}}),_c('path',{attrs:{"fill":"#335560","d":"M60.8 69.5h24v13.6h-24z"}}),_c('g',[_c('path',{attrs:{"fill":"#EB5949","d":"M96.6 14.2h24v4.9h-24z"}}),_c('path',{attrs:{"fill":"#C5D6D9","d":"M96.6 19.2h24v12.5h-24z"}}),_c('path',{attrs:{"fill":"#44A7C7","d":"M96.6 31.6h24v20.1h-24z"}}),_c('path',{attrs:{"fill":"#335560","d":"M96.6 51.8h24v31.4h-24z"}})]),_c('g',[_c('path',{attrs:{"fill":"#EB5949","d":"M132.5 32.3h24v7.9h-24z"}}),_c('path',{attrs:{"fill":"#C5D6D9","d":"M132.5 40.2h24v9.3h-24z"}}),_c('path',{attrs:{"fill":"#44A7C7","d":"M132.5 49.4h24v20h-24z"}}),_c('path',{attrs:{"fill":"#335560","d":"M132.5 64.1h24v19.1h-24z"}})]),_c('g',[_c('path',{attrs:{"opacity":".1","fill":"#020203","stroke":"#788488","d":"M0 83.1h172M0 71.9h172M0 60.1h172M0 48.5h172M0 37.5h172M0 25.7h172M0 14.5h172"}})])])
          )
        }
      }
    